<template>
  <CamMap />
   <div>
    
   </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CamMap from "../../components/CamMap/CamMap.vue";

export default defineComponent({
  name: "CamMapPage",
  components: {
    CamMap
  },
});
</script>